export default "__VITE_ASSET__D3M$trn___"